import { Alert, Box, Stack, Text } from "@sembark-travel/ui/base"
import { Breadcrumbs, Link } from "@sembark-travel/ui/router"
import { Helmet } from "react-helmet-async"
import { AddPriceForm } from "./../../../TransportServicePrices"
import { generatePath, useNavigate } from "../../../router-utils"

export default function NewTransportService() {
	const navigate = useNavigate()
	function navigateToList() {
		return navigate("/transport-service-prices", { replace: true })
	}
	return (
		<>
			<Helmet>
				<title>Add Transport Service Prices</title>
			</Helmet>
			<Alert status="warning" title="Deprecated" rounded="none">
				<Stack gap="1">
					<Text>
						Transport cab metrics prices have been moved to{" "}
						<Link
							to={generatePath("/data-drive/folders/new/metric")}
							fontWeight="semibold"
							textDecoration={"underline"}
						>
							Data Drive
						</Link>
						. Now you can bulk upload prices.
					</Text>
					<Text>This section will be removed in upcoming updates.</Text>
					<Text>Please provide your feedback in our support channel.</Text>
				</Stack>
			</Alert>
			<Breadcrumbs
				title="Add Price"
				items={[
					[generatePath("/transport-service-prices"), "Transportation Prices"],
					["", "Add Price"],
				]}
			/>
			<Box>
				<AddPriceForm onSuccess={navigateToList} onCancel={navigateToList} />
			</Box>
		</>
	)
}
